import React from 'react';

type ItemListProps = {
  children: React.ReactNode;
  title: string;
  titleColor?: string;
  textColor?: string;
  hoverTextColor?: string;
  hoverBackGround?: string;
  scrollBarColor?: string;
  width?: string;
  height?: string;
  maxHeight?: string;
  overflowHidden?: boolean;
};

const ItemList: React.FC<ItemListProps> = ({
  children,
  title = '',
  titleColor = 'text-BADBlue',
  scrollBarColor = 'scrollbar-thumb-BAMPink',
  width = 'w-[290px]',
  height = 'h-auto',
  maxHeight = 'max-h-60',
  overflowHidden = false
}) => {
  const displayOverflow = overflowHidden ? 'overflow-hidden' : 'overflow-y-auto';

  return (
    <div className={`${width}`}>
      <h2 className={`text-lg font-bold ${titleColor} px-1 pb-3`}>{title}</h2>
      <div
        className={`${width} ${height} ${maxHeight} ${displayOverflow} scrollbar-thin scrollbar-track-BALGray ${scrollBarColor}`}
      >
        {children}
      </div>
    </div>
  );
};

export default ItemList;